import React from 'react'
import { Form } from 'semantic-ui-react'
import { Field } from 'react-final-form'
import { Photos } from '../Form/Photos/Photos'

export const Images = () => (
  <Form.Field>
    <Field name="image_urls">
      {(props) => <Photos onChange={props.input.onChange} image_urls={props.input.value} />}
    </Field>
  </Form.Field>
)
